export default __webpack_public_path__ + "static/media/arrow-backward-icon.b3a11c78.svg";